<template>

  <div>
    <div class="bg-white">
      <br class="d-none d-lg-block">
    	<br>
    	<div class="container py-1">
    	  <br class="d-none d-md-block">
    	  <div class="row">
    	    <div class="col-lg-6">
    	      <h1 class="h3">{{ `Trailer Rental in ${countriesStr('and')}` }}</h1>
    	      <p class="lead grey">Rent a trailer with <strong>PNO Rental</strong> for your next transportation need.</p>
			<hr>
			<p class="text-lg d-none d-sm-block">{{`Find a semi-trailer in ${countriesStr('or')} that fit your transportation needs. Trailers include Curtain Trailers, Reefer Trailers, Box Trailers, and more - all available for flexible short-term rental with PNO Rental.`}}</p>
			<p><a href="/trailers" class="btn btn-lg btn-success px-4">Search trailers <i class="fa fa-chevron-right ml-1"></i></a></p>
    	    </div>
    	    <div class="col-lg-6 col-xl-5 offset-xl-1">
            <img :src="require('@/assets/img/bg_pno_lineup.jpg')" class="img-fluid mb-3" alt="Trailer Rental">
    			</div>
    	  </div>
    	</div>
    	<br class="d-none d-md-block">
    </div>

    <div class="container py-4 text-center">
    	<br class="d-none d-md-block">
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <h2>Cost-competitive and flexible trailer rental</h2>
          <hr>
          <p class="lead grey pt-2">Trailers types available for rent:</p>
          <ul class="list-unstyled list-inline lead">
			<li class="list-inline-item mr-4 mb-3"><a href="/trailer-rental/curtain-trailer-rental" class="text-info">Curtain Trailers</a></li>
			<li class="list-inline-item mr-4 mb-3"><a href="/trailer-rental/reefer-trailer-rental" class="text-info">Reefer Trailers</a></li>
			<li class="list-inline-item mr-4 mb-3"><a href="/trailer-rental/box-trailer-rental" class="text-info">Box Trailers</a></li>
            <li class="list-inline-item mr-4 mb-3"><a href="/trailer-rental/moving-floor-trailer-rental" class="text-info">Moving Floor Trailers</a></li>
            <li class="list-inline-item mr-4 mb-3"><a href="/trailer-rental/dolly-trailer-rental" class="text-info">Dolly Trailers</a></li>
            <li class="list-inline-item mr-4 mb-3"><a href="/trailer-rental/flatbed-trailer-rental" class="text-info">Flatbed Trailers</a></li>
            <li class="list-inline-item mr-4 mb-3"><a href="/trailer-rental/container-chassis-trailer-rental" class="text-info">Container Chassis Trailers</a></li>
    	  </ul>
        </div>
      </div>
    </div>
  
    <pno-how />

    <pno-prompt />
  
  </div>

</template>

<script>
import PnoHow from '@/components/PnoHow.vue'
import PnoPrompt from '@/components/PnoPrompt.vue'
import { countriesStr } from '@/assets/countries'
export default {
  methods: {
    countriesStr
  },
	mounted() {
      this.$store.commit('meta/title', 'Cost-competitive and flexible short-term trailer rental with PNO Rental. Trailers include Curtain Trailers, Reefer Trailers, Box Trailers, and more. Get your quote today!')
      this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/bg_pno_lineup.jpg') , 'ogimage'));
  },
  components: { PnoHow, PnoPrompt },
}
</script>
